/* eslint-disable @typescript-eslint/no-namespace */
import blockquote, { blockquoteVariants } from './blockquote';
import type { Utility } from '../../../types/utility';

export namespace Quote {
  /** Quote Component Variant Keys */
  export type ComponentKeys = 'blockquote';

  /** Quote Components */
  export type Components = {
    /** The Quote blockquote subcomponent types. */
    Blockquote: Blockquote.Variants;
  };

  /** Quote Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'blockquote' ? Blockquote.Variants : never;
  };

  /** Quote Component Variant Modes */
  export type VariantModes = {
    [CompKey in ComponentKeys]: Utility.VariantModes<CompKey extends 'blockquote' ? Blockquote.Variants : never>;
  };

  export namespace Blockquote {
    /** Quote Blockquote Component Variant Keys */
    export type VariantKeys = 'default';

    /** Quote Blockquote Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Quote Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: CompKey extends 'blockquote' ? Array<`${CompKey}.${Blockquote.VariantKeys}`> : never;
  };
}

const quote = {
  blockquote,
};

export const quoteVariants = {
  blockquote: blockquoteVariants,
};

export default quote;
